import React from "react";

interface QuartileMainProps {
  x?: number; // Wert zwischen 0 und 4 (entspricht 0-600px)
  width?: number; // Wert zwischen 0 und 4 (entspricht 0-600px)
}

const QuartileMain: React.FC<QuartileMainProps> = ({
  x = 1.19, // Default: ca. 179px bei Skalierung 0-4 → 0-600
  width = 0.4, // Default: ca. 60px bei Skalierung 0-4 → 0-600
}) => {
  // Umrechnung: 0-4 → 0-600px
  const scaledX = (x / 4) * 600;
  const scaledWidth = (width / 4) * 600;

  return (
    <svg
      className="quartile-main"
      preserveAspectRatio="none"
      viewBox="0 0 600 6"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x={scaledX} y={0} width={scaledWidth} height={6} fill="white" />
    </svg>
  );
};

export default QuartileMain;
